import React, { useState } from "react";
import FadeInOut from "../FadeInOut/FadeInOut";
import { Box, Card, Stack } from "@mui/material";
import {
  ArrowDownInactive,
  ArrowDownHover,
  ArrowUpInactive,
} from "../../ImageRepo";
import "./MenuBlock.css";

const MenuBlock = ({
  title,
  maxHeight,
  duration,
  iconHover,
  iconInactive,
  className,
  subMenu,
  children,
}) => {
  const [expanded, setExpanded] = useState(false);
  const toggleMenu = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <Card
        className={
          "menu-block" +
          (expanded ? " menu-block-open" : "") +
          (subMenu ? " sub-menu" : "")
        }
        onClick={toggleMenu}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Stack direction="row" alignItems="center">
          {iconInactive != null && iconHover != null && (
            <Box>
              <img className="inactive" src={iconInactive} />
              <img className="hover" src={iconHover} />
            </Box>
          )}
          <Box style={{ margin: "4px 0px 0px 10px" }}>{title}</Box>
        </Stack>
        <Stack className="arrow" direction="column" justifyContent="center">
          <img className="inactive" src={ArrowDownInactive} />
          <img className="hover" src={ArrowDownHover} />
          <img className="open" src={ArrowUpInactive} />
        </Stack>
      </Card>
      <FadeInOut
        show={expanded}
        duration={duration >= 100 ? duration : 600 + maxHeight * 0.5}
        maxHeight={maxHeight}
        className={className}
        style={{ paddingBottom: "2px" }}
      >
        {children}
      </FadeInOut>
    </>
  );
};

export default MenuBlock;
